// Dependency
import { Base64 } from 'js-base64';

// Version Constant
export const SYSTEM_VERSION = '20200831';

// System Name (Front-Office, Back-Office)
// Reporting Beach Personal Information
export const SYSTEM_NAME_FRONTOF = `Reporting Breach Personal Information`;
export const SYSTEM_NAME_FRONTOF_INIT = `Reporting Breach Personal Info.`;
export const SYSTEM_NAME_FRONTOF_TH = `ระบบแจ้งเหตุละเมิดข้อมูลส่วนบุคคล`;
export const SYSTEM_NAME_FRONTOF_INIT_TH = `แจ้งเหตุละเมิดข้อมูลส่วนบุคคล`;
export const SYSTEM_NAME_BACKOF = `PDPA Incident Management`;
export const SYSTEM_NAME_BACKOF_INIT = `PDPA-IM`;

export const drawer = {
  width: 220,
  rightWidth: 280,
};

// User permission list
export const USER_PERMISSION_FETCH_LIST_PROCESSING =
  'USER_PERMISSION_FETCH_LIST_PROCESSING';
export const USER_PERMISSION_FETCH_LIST_FAILED =
  'USER_PERMISSION_FETCH_LIST_FAILED';
export const USER_PERMISSION_FETCH_LIST_SUCCESS =
  'USER_PERMISSION_FETCH_LIST_SUCCESS';
export const USER_PERMISSION_FETCH_LIST_CLEAR =
  'USER_PERMISSION_FETCH_LIST_CLEAR';

// Element id - html
export const ID_APPTOOLBAR_NAVIGATOR = 'appToolBar-navigator';

// Error Code
export const E_PICKER_CANCELLED = 'E_PICKER_CANCELLED';
export const E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR =
  'E_PICKER_CANNOT_RUN_CAMERA_ON_SIMULATOR';
export const E_PERMISSION_MISSING = 'E_PERMISSION_MISSING';
export const E_PICKER_NO_CAMERA_PERMISSION = 'E_PICKER_NO_CAMERA_PERMISSION';
export const E_USER_CANCELLED = 'E_USER_CANCELLED';
export const E_UNKNOWN = 'E_UNKNOWN';
export const E_DEVELOPER_ERROR = 'E_DEVELOPER_ERROR';
export const TIMEOUT_NETWORK = 'ECONNABORTED'; // request service timeout
export const NOT_CONNECT_NETWORK = 'NOT_CONNECT_NETWORK';

// Localization Begin
export const NETWORK_CONNECTION_MESSAGE =
  'Cannot connect to server, Please try again.';
export const NETWORK_TIMEOUT_MESSAGE =
  'A network timeout has occurred, Please try again.';
export const UPLOAD_PHOTO_FAIL_MESSAGE =
  'An error has occurred. The photo was unable to upload.';

/**
 * Action of reducer
 */

// Action of issue
export const ISSUE_LIST_FETCH_PROCESSING = 'ISSUE_LIST_FETCH_PROCESSING';
export const ISSUE_LIST_FETCH_FAILED = 'ISSUE_LIST_FETCH_FAILED';
export const ISSUE_LIST_FETCH_SUCCESS = 'ISSUE_LIST_FETCH_SUCCESS';
export const ISSUE_LIST_FETCH_CLEAR = 'ISSUE_LIST_FETCH_CLEAR';

export const ISSUE_FETCH_PROCESSING = 'ISSUE_FETCH_PROCESSING';
export const ISSUE_FETCH_FAILED = 'ISSUE_FETCH_FAILED';
export const ISSUE_FETCH_SUCCESS = 'ISSUE_FETCH_SUCCESS';
export const ISSUE_FETCH_CLEAR = 'ISSUE_FETCH_CLEAR';

export const ISSUE_UPDATE_SUCCESS = 'ISSUE_UPDATE_SUCCESS';
export const ISSUE_UPDATE_FAILED = 'ISSUE_UPDATE_FAILED';

// Action of issue-comment
export const ISSUE_COMMENT_FETCH_PROCESSING = 'ISSUE_COMMENT_FETCH_PROCESSING';
export const ISSUE_COMMENT_FETCH_FAILED = 'ISSUE_COMMENT_FETCH_FAILED';
export const ISSUE_COMMENT_FETCH_SUCCESS = 'ISSUE_COMMENT_FETCH_SUCCESS';
export const ISSUE_COMMENT_FETCH_CLEAR = 'ISSUE_COMMENT_FETCH_CLEAR';

export const ISSUE_COMMENT_UPDATE_FAILED = 'ISSUE_COMMENT_UPDATE_FAILED';
export const ISSUE_COMMENT_UPDATE_SUCCESS = 'ISSUE_COMMENT_UPDATE_SUCCESS';

// Action of issueLog
export const ISSUE_LOG_FETCH_PROCESSING = 'ISSUE_LOG_FETCH_PROCESSING';
export const ISSUE_LOG_FETCH_FAILED = 'ISSUE_LOG_FETCH_FAILED';
export const ISSUE_LOG_FETCH_SUCCESS = 'ISSUE_LOG_FETCH_SUCCESS';
export const ISSUE_LOG_FETCH_CLEAR = 'ISSUE_LOG_FETCH_CLEAR';

export const ISSUE_LOG_UPDATE_SUCCESS = 'ISSUE_LOG_UPDATE_SUCCESS';
export const ISSUE_LOG_UPDATE_FAILED = 'ISSUE_LOG_UPDATE_FAILED';

// Action of analystIncident
export const ANALYST_INCIDENT_FETCH_PROCESSING =
  'ANALYST_INCIDENT_FETCH_PROCESSING';
export const ANALYST_INCIDENT_FETCH_FAILED = 'ANALYST_INCIDENT_FETCH_FAILED';
export const ANALYST_INCIDENT_FETCH_SUCCESS = 'ANALYST_INCIDENT_FETCH_SUCCESS';
export const ANALYST_INCIDENT_FETCH_CLEAR = 'ANALYST_INCIDENT_FETCH_CLEAR';

export const ANALYST_INCIDENT_UPDATE_SUCCESS =
  'ANALYST_INCIDENT_UPDATE_SUCCESS';
export const ANALYST_INCIDENT_UPDATE_FAILED = 'ANALYST_INCIDENT_UPDATE_FAILED';

/**
 * Config SysHost, config hostname of each site (prd, qas, dev)
 */
const confSysHost = {
  prd: 'incident-pdpa.mahidol.ac.th',
  qas: 'incident-pdpa-qas.mahidol.ac.th',
  dev: 'localhost',
};

/**
 * Config SysDomain, config domain  of each site (prd, qas, dev)
 * NOTE: Domain is hostname included protocol.
 */
const confSysDomain = {
  prd: `https://${confSysHost.prd}`,
  qas: `https://${confSysHost.qas}`,
  dev: `http://${confSysHost.dev}`,
};

/**
 * Config SysURL, config url of each site (prd, qas, dev)
 * NOTE: url is a endpoint of system.
 */
const configSysURL = {
  web: {
    prd: confSysDomain.prd,
    qas: confSysDomain.qas,
    dev: `${confSysDomain.dev}:3000`,
  },
  api: {
    prd: `${confSysDomain.prd}/api`,
    qas: `${confSysDomain.qas}/api`,
    dev: `${confSysDomain.qas}/api`, //${confSysDomain.dev}:8008
  },
};

// Config JWL resouce,
const confJWT = {
  urlAuthen: 'https://jwt.mahidol.ac.th/v1/authen',
  urlAuthenStatus: 'https://jwt.mahidol.ac.th/v1/status',
  urlAuthenAccess: 'https://jwt.mahidol.ac.th/v1/access',
  urlPublicKey: 'https://jwt.mahidol.ac.th/v1/publickey',
  urlAdfsAuthen: 'https://jwt.mahidol.ac.th/adfs/v1/authen',
  adfsSysKey: {
    prd: '64adcc91a9e54e87dbaf69a1dffe1742343d9f59',
    qas: '492847b66fcb69a06c4b821e324d51e8ed131879',
    dev: '7858a0e06434718dc4b5271c6d36f938eaa12d2d',
  },
};

/**
 * Config serverFake const
 */
const configAPIURLFake = {
  dev: 'http://127.0.0.1:1880/pdpa', // NODERED Local Server
  qas: 'https://dw-pandora.mahidol.ac.th/service/pdpa', // NODERED QAS (DW) Server
  prd: 'https://dw-pandora.mahidol.ac.th/service/pdpa', // NODERED QAS (DW) Server
};

/**
 * mapValuesBySite: map keySite (of pairSite) that matched with key of confSysDomain by hostname
 * @param {object} pairSite , (object) sites-value default { prd: "PRD", qas:  "QAS",  dev:  "DEV"}
 * @return {object} value of pairSite that keySite matched;
 */
const mapValuesBySite = (
  pairSite = { prd: 'PRD', qas: 'QAS', dev: 'DEV' },
  configSystemHost = confSysHost
) => {
  const hostname = window.location.hostname;
  //Find keySite from hostname
  const keySite = Object.keys(configSystemHost).find(
    (key) => configSystemHost[key] === hostname
  );
  return pairSite[keySite];
};

/** =========================================================
 *   server constant, consist of
 *    1 API-Enpoints,
 *    2 Stroage-Keys
 * =========================================================
 */

/**
 * EXPORT: server const
 */
export const server = {
  // Localstorage Key
  REFRESH_TOKEN_KEY: 'refresh_token',
  ACCESS_TOKEN_KEY: 'access_token',
  USER_PROFILE_KEY: 'user_profile',
  ISSUE_FILTERS_KEY: 'issue_filters',

  // request param-mode
  REQ_PARAM_MODE_REPORTER: 'reporter',
  REQ_PARAM_MODE_STAFF: 'staff',

  // API URL/Enpoint
  USER_URL: '/user/v1',
  PERMISSION_LEVEL_URL: '/permissionLevel/v1',
  CATEGORY_URL: '/category/v1',
  PERMISSION_GROUP_URL: '/permissionGroup/v1',
  LABEL_URL: '/label/v1',
  DIMENSION_URL: '/dimension/v1',
  PROCESS_STATUS_URL: '/processStatus/v1',
  ISSUE_URL: '/issue/v1',
  ISSUE_COMMEMNT_URL: '/issueComment/v1',
  ISSUE_LOG_URL: '/issueLog/v1',
  OBSERVER_URL: '/observer/v1',
  FILE_URL: '/image/v1',
};

const urlAPIFake = mapValuesBySite(configAPIURLFake);

export const serverFake = {
  ISSUE_URL: `${urlAPIFake}/issue/v1`,
};

/**
 * =========================================================
 *   sysURL constant, consist of
 *    1 adfsAuthen URL
 *    2 accessToken URL
 *    3 api & web URL
 * =========================================================
 */

// Get adfsSystemKey by site
const adfsSystemKey = mapValuesBySite(confJWT.adfsSysKey);

/**
 * EXPORT sysURL
 */
export const sysURL = {
  adfsAuthen: `${confJWT.urlAdfsAuthen}/${adfsSystemKey}`,
  accessToken: (() => {
    let packageParam = '';
    try {
      packageParam = Base64.encode(
        `${localStorage.getItem(server.REFRESH_TOKEN_KEY)}.${adfsSystemKey}`
      );
    } catch (error) {}
    return `${confJWT.urlAuthenAccess}?package=${packageParam}`;
  })(),
  api: mapValuesBySite(configSysURL.api),
  web: mapValuesBySite(configSysURL.web),
};

/**
 * masterData constants consist of:
 *  - process
 *  - issue
 * In each options has structure below:
 * { value: 'key/value', text: 'display text', style: 'style of status' }
 */
export const masterData = {
  permissionGroups: [
    { id: 1, title: 'กลุ่มผู้ดูแลข้อมูล กลุ่มที่ 1' },
    { id: 2, title: 'กลุ่มผู้ดูแลข้อมูล กลุ่มที่ 2' },
    {
      id: 3,
      title: 'กลุ่มผู้ดูแลข้อมูล กลุ่มที่ 3',
    },
  ],
  commentTypes: [
    // Doc 1.	เหตุการณ์เกิดขึ้นได้อย่างไร, Doc 2.	ใครเป็นคนพบเหตุการณ์ดังกล่าว [info issue lv0]
    { id: 1, title: 'สาเหตุของเหตูการณ์ที่เกิดขึ้น' },

    // Doc 3.	วันและเวลาที่เหตุการณ์เกิดขึ้น
    { id: 2, title: 'วันและเวลาที่เหตุการณ์เกิดขึ้น' },

    // Doc 4.	มีการดำเนินการเบื้องต้นอย่างไรในการจำกัดผลกระทบเนื่องจากเหตุการณ์
    {
      id: 3,
      title: 'การดำเนินการเบื้องต้นอย่างไรในการจำกัดผลกระทบเนื่องจากเหตุการณ์',
    },

    // Doc 5. มีการดำเนินการอย่างไรที่ใช้ในการจัดการเหตุการณ์ดังกล่าว
    { id: 4, title: 'การดำเนินการที่ใช้ในการจัดการเหตุการณ์' },

    // Doc 6.	มีบุคคลที่สามเกี่ยวข้องกับการจัดการเหตุการณ์หรือไม่
    { id: 5, title: 'บุคคลที่สามเกี่ยวข้องกับการจัดการเหตุการณ์' },

    // Doc 7.	ในกรณีถ้ามีบุคคลที่สามเกี่ยวข้อง มีการดำเนินการอย่างไร
    { id: 6, title: 'การดำเนินการ ในกรณีถ้ามีบุคคลที่สามเกี่ยวข้อง' },
  ],
};

export const sortingOptions = {
  issues: [
    { name: 'issues.createDate', title: 'วันที่แจ้ง' },
    { name: 'issues.modifyDate', title: 'วันที่ปรับปรุง' },
    { name: 'categorys.name', title: 'ประเภท' },
    { name: 'issues.level', title: 'ระดับ' },
    { name: 'processStatuses.id', title: 'สถานะการดำเนินการ' },
  ],
};

/**
 * =================================================================
 *   muiTable constanst is the config of material-table, consist of
 *    1 options (Change behaviour of grid)
 *    2 components (Component customization)
 * =================================================================
 */
export const muiTable = {
  options: {
    // Change column index of action (edit, delete column)
    actionsColumnIndex: -1,

    // set default pageSize option.
    pageSize: 10,

    // set default headerStyle  option.
    headerStyle: { fontWeight: 'bold' },
    rowStyle: { fontSize: '0.98em' },
  },
  localization: {
    header: {
      actions: 'Actions',
    },
    toolbar: {
      searchPlaceholder: 'ค้นหา',
    },
    body: {
      emptyDataSourceMessage: 'ไม่มีรายการข้อมูล',
    },
    pagination: {
      labelRowsPerPage: 'รายการต่อหน้า',
      labelDisplayedRows: `{from}-{to} จาก {count}`,
      labelRowsSelect: 'รายการ',
      firstAriaLabel: 'หน้าแรก',
      firstTooltip: 'หน้าแรก',
      previousAriaLabel: 'หน้าก่อน',
      previousTooltip: 'หน้าก่อน',
      nextAriaLabel: 'หน้าถัดไป',
      nextTooltip: 'หน้าถัดไป',
      lastAriaLabel: 'หน้าสุดท้าย',
      lastTooltip: 'หน้าสุดท้าย',
    },
  },
};

export const regexes = {
  emailFormat: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
export const invalidMessages = {
  emailFormat: 'รูปแบบอีเมลไม่ถูกต้อง',
};

export const labels = {
  selectMultipleEmails: 'ค้นหาและจัดการอีเมล',
};

// Mock data for test
const _mockEmails = {
  options: [
    { email: 'email1@example.com' },
    { email: 'email2@example.com' },
    { email: 'email3@example.com' },
  ],
};

_mockEmails.create = [
 _mockEmails.options[0],
  _mockEmails.options[1],
];
_mockEmails.update = [
  _mockEmails.options[0],
  _mockEmails.options[2],
];

export const mockEmails = _mockEmails;
